import React, { Suspense, useEffect } from "react";
import { Route, Routes, useNavigate, Navigate } from "react-router-dom";
import { LoggedInRoutes } from "./allRoutes";
import LoggedInLayout from "../Layout/LoggedInLayout/LoggedInLayout";
import Home from "../Pages/Home/Home";

import { useAtom } from "jotai";
import {
  auth_token,
  Login_Success,
  parentProfile,
  userstate,
} from "../AtomStore/store";
import Survey from "../Pages/Survey/Survey";
import { fetchConstants } from "../QueryFunctions/queryfunction";
import { useRequestProcessor } from "../requestProcessor";
import { getAuthToken } from "../AtomStore/ServiceAtoms";

import LoggedOut from "../Layout/LoggedOutLayout/LoggedOut";
import LoginMobile from "../Pages/Login/Login";
import LoginVerifyMobile from "../Pages/Login/LoginVerify";
import { Capacitor } from "@capacitor/core";

import Constants from "../constants";
import {
  sendUnsentReports,
  setContext,
  setEnabled,
  setUserId,
} from "../Components/crashlyticsMethods";
import SpinnerLoading from "../Components/utils/SpinnerLoading";

const Index = () => {
  const [loginSuccess] = useAtom(Login_Success);
  const token = localStorage.getItem("auth_token");
  const { useQueryWrapper } = useRequestProcessor();
  const navigate = useNavigate();
  const parent = useAtom(parentProfile);

  const [user] = useAtom(userstate);

  useEffect(() => {
    let authToken = localStorage.getItem("auth_token");
    if (!authToken || authToken === "") {
      navigate("/login");
    }
    //  else {
    //   navigate('/blogs');
    // }
    // fetchConstant.mutate();
    // eslint-disable-next-line react-hooks/exhaustive-deps

    // Capacitor crashlytics setup and backButton handling
    if (Capacitor.isNativePlatform()) {
      sendUnsentReports();
      setEnabled(true);

      const contextData = {
        parentDetails: parent,
        lastLoginUI: user?.lastLoggedIn,
        loggedInUserData: {
          email: user?.email,
          password: user?.password,
          phone: user?.phone,
        },
        apiVersion: Constants.env.version,
        uiVersion: Constants.env.version,
      };

      setContext("UserData", contextData);
      setUserId(user?.activeChildDetail?.id);
    }
  }, []);
  console.log("token", token);
  console.log("user data", user);
  const {} = useQueryWrapper("constants", () => fetchConstants());
  const isValidToken = token && token !== "" && token !== '""';
  return (
    <React.Fragment>
      <Suspense>
        {/* Show NetworkError if offline */}
        <Routes>
          <Route path="/" element={<Home />} />

          <Route>
            <Route
              path="/login"
              element={
                <LoggedOut>
                  {loginSuccess ? <LoginVerifyMobile /> : <LoginMobile />}
                </LoggedOut>
              }
            />
          </Route>

          <Route path="/survey/:surveyId" element={<Survey />}></Route>

          <Route>
            {LoggedInRoutes.map((route, idx) => (
              <Route
                path={route.path}
                element={
                  isValidToken ? (
                    <LoggedInLayout>
                      <route.component />
                    </LoggedInLayout>
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
                key={idx}
              />
            ))}
          </Route>
        </Routes>
      </Suspense>
    </React.Fragment>
  );
};

export default Index;
